import { Editor } from "@tinymce/tinymce-react";
import { useCallback } from "react";

const apiKey = import.meta.env.VITE_TINYMCE_API_KEY;
export default function BundledEditor(props) {
  const { init, ...restProps } = props;

  const parentId = init?.selector?.replace('#', '');
  const markResizerContainer = useCallback(() => {
    setTimeout(() => {
      const resizerContainers = document.querySelectorAll('[id^="resizer-container_"]');
      const newResizerContainer = Array.from(resizerContainers).find(
        container => !container.hasAttribute('data-editor-id')
      );
      // Add data-editor-id and className to the resizer-container_ element
      if (newResizerContainer && parentId) {
        newResizerContainer.setAttribute('data-editor-id', parentId);
        newResizerContainer.className = 'hidden-resizer';
      }
    }, 0);
  }, [init, props.shouldCreateResizer, parentId]);

  const modifiedInit = {
    ...init,
    setup: (editor) => {
      if (init && init.setup) {
        init.setup(editor);
      }

      editor.on('init', () => {
        markResizerContainer();
      });
    },
  };

  return <Editor init={modifiedInit} {...restProps} apiKey={apiKey} />
}
